import {Directive, ElementRef, HostListener, Input} from '@angular/core';
import {ActiveFormService} from '../../../modules/flow/services/active-form.service';
import {FormGroup} from '@angular/forms';

@Directive({
    selector: '[activeForm]'
})
export class ActiveFormDirective {

    id: string;
    @Input() activeForm: FormGroup;

    @HostListener('focus') onFocus() {
        if (this.id) {
            this.elementRef.nativeElement.name = this.id;
        }
        const id = this.id ? this.id : this.elementRef.nativeElement.name;
        this.activeFormService.setActiveForm(this.activeForm);
        this.activeFormService.setPosition(id, id, this.elementRef.nativeElement);
        this.activeFormService.setFocusStatus(id, id);
    }

    @HostListener('blur', ['$event']) onBlur(event) {
        const relatedTarget = event.relatedTarget as HTMLElement;
        if (relatedTarget) {
            if (relatedTarget.classList.contains('variable_burgerMenu') || relatedTarget.attributes.getNamedItem('activeform')) {
                return;
            }
        }

        this.activeFormService.clearFocus();
    }

    constructor(private elementRef: ElementRef, private activeFormService: ActiveFormService) {
        this.id = this.elementRef.nativeElement.id;
    }
}
